import React, { createContext } from "react";
import axios from "./backendAxios";
// eslint-disable-next-line no-restricted-imports
import { AxiosInstance } from "axios";
// import { tokenSupplier } from "./webAuth";
const backend = axios;
// backend.defaults.withCredentials = true;
// backend.interceptors.request.use(async function (config) {
//   const token = await tokenSupplier.getToken();
//   if (token) {
//     config.headers.Authorization = token;
//   }
//   return config;
// });
export const AxiosContext = createContext<AxiosInstance>(backend);
const AxiosService = ({ children }: { children: React.ReactNode }) => {
  return (
    <AxiosContext.Provider value={axios}>{children}</AxiosContext.Provider>
  );
};

export default AxiosService;
